<template>
  <div :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">
    <feather-icon icon="Edit3Icon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="editRecord" v-show="isEditable" />
    <feather-icon icon="XIcon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="openCancelApprobation" v-show="!isEditable" />
    <feather-icon icon="Trash2Icon" svgClasses="h-5 w-5 hover:text-danger cursor-pointer" @click="openDeleteConfirm" v-show="isEditable" />
  </div>
</template>

<script>
export default {
  name: 'AnnualForecastActionsCellRenderer',
  computed: {
    isEditable() {
      return this.params.data.approbationDate === null;
    }
  },
  methods: {
    editRecord() {
      this.params.context.componentParent.editData(this.params.data);
    },

    openCancelApprobation() {
      this.$vs.dialog({
        type: "confirm",
        color: "warning",
        title: this.$t('GradeControl.Forecast.Annual.Title'),
        text: this.$t('GradeControl.Forecast.Annual.ConfirmCancelApprobation'),
        accept: this.cancelApprobation
      });
    },

    cancelApprobation() {
      this.params.context.componentParent.cancelApprobation([this.params.data.annualLocationForecastId]);
    },

    openDeleteConfirm() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: this.$t('GradeControl.Forecast.Annual.Title'),
        text: this.$t('GradeControl.Forecast.Annual.ConfirmDelete'),
        accept: this.deleteRecord
      });
    },

    deleteRecord() {
      this.params.context.componentParent.deleteMany([this.params.data.annualLocationForecastId]);
    }
  }
}
</script>
